import { render, staticRenderFns } from "./webOfficePage.vue?vue&type=template&id=53eea7c2"
import script from "./webOfficePage.vue?vue&type=script&lang=js"
export * from "./webOfficePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports